import styled from 'styled-components';

export const FeedbackInfoWrapper = styled.div`
  & > div:first-child {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: 12px;
  }
`;

export const ElementWrapper = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-row-gap: 16px;
`;

export const InfoElement = styled.div`
  display: flex;
  margin-bottom: 14px;
  & > div:first-child {
    margin-right: 8px;
  }
`;
